export default __webpack_public_path__ + "static/media/B4.f0464440.mp3";